import React, { useContext, useEffect, useState } from "react"
import {Link, Redirect} from "react-router-dom"
import logo240 from '../assets/images/logo240.png'
import "../App.css"
import { useHistory } from 'react-router-dom'
import { WEB_URL } from "../services/Api"
import { isLogin } from "../App"
import Cookies from "js-cookie"
import MotevafaInsert from "./MotevafaInsert";

const TopNav = (props) => {
  const history = useHistory()
  const logined = useContext(isLogin)
  const [searchText, setSearchText] = useState('')

  useEffect(() => {
    console.log('logined:: ' + logined)
  }, [])

  return (
    <>
      <div className="top-navigation">
        <div className="container">
          <nav role="navigation">
            <div id="menuToggle" >
              <input type="checkbox" />
              <span></span>
              <span></span>
              <span></span>
              <ul id="menu">
                <a onClick={() => window.location.assign('/')}><li>خانه</li></a>
                <a href="./profile-first"><li>مزار آنلاین</li></a>
                <a className="clickable" onClick={() => window.location.assign('/mohsenin')}><li>محسنین</li></a>
                <a className="clickable" onClick={() => window.location.assign('/states')}><li>یادبودها</li></a>
                {localStorage.getItem('token') != null ? <a className="clickable" onClick={() => window.location.assign('/khatm-archive?mine=true')}><li>ختم ادعیه و صلوات</li></a> : <a className="clickable" onClick={() => window.location.assign('/login')}><li>ختم ادعیه و صلوات</li></a>}

                <a className="clickable" onClick={() => window.location = './donate'}><li>کمک و حمایت مالی</li></a>
                <a href="./contact"><li>ارتباط با ما</li></a>
                <a href="./about" target="_blank"><li>درباره ما</li></a>
                <a className="clickable" onClick={() => {
                  if (logined) {
                    localStorage.clear()
                    document.cookie.split(";").forEach((c) => {
                      document.cookie = c
                        .replace(/^ +/, "")
                        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
                    });
                  }
                  window.location = './login'
                }} target="_blank"><li>{logined ? 'خروج' : 'ورود'}</li></a>
              </ul>
            </div>
          </nav>
          <div className="search-button radius100 ease">
            <svg version="1.1" width={30} height={30} fill="#fff" className="ease" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style={{ enableBackground: 'new 0 0 512 512' }} xmlSpace="preserve"> <g> <g> <path d="M447.615,64.386C406.095,22.866,350.892,0,292.175,0s-113.92,22.866-155.439,64.386 C95.217,105.905,72.35,161.108,72.35,219.824c0,53.683,19.124,104.421,54.132,144.458L4.399,486.366 c-5.864,5.864-5.864,15.371,0,21.236C7.331,510.533,11.174,512,15.016,512s7.686-1.466,10.617-4.399l122.084-122.083 c40.037,35.007,90.775,54.132,144.458,54.132c58.718,0,113.919-22.866,155.439-64.386c41.519-41.519,64.385-96.722,64.385-155.439 S489.134,105.905,447.615,64.386z M426.379,354.029c-74.001,74-194.406,74-268.407,0c-74-74-74-194.407,0-268.407 c37.004-37.004,85.596-55.5,134.204-55.5c48.596,0,97.208,18.505,134.204,55.5C500.378,159.621,500.378,280.028,426.379,354.029z" /> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
          </div>
          <div action id="search" role="search" className="box-sizing radius50" method="get">
            <input type="text" placeholder="جستجو کنید" value={searchText} onChange={(e) => setSearchText(e.target.value)} className="text" onKeyDown={(e) => {
              if (e.key == 'Enter') {
                window.location = './d-list?d-name=' + searchText
              }
            }} />
            <div className="line" />
            <svg version="1.1" width={30} height={30} fill="#fff" className="search-icon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style={{ enableBackground: 'new 0 0 512 512' }} xmlSpace="preserve"> <g> <g> <path d="M447.615,64.386C406.095,22.866,350.892,0,292.175,0s-113.92,22.866-155.439,64.386 C95.217,105.905,72.35,161.108,72.35,219.824c0,53.683,19.124,104.421,54.132,144.458L4.399,486.366 c-5.864,5.864-5.864,15.371,0,21.236C7.331,510.533,11.174,512,15.016,512s7.686-1.466,10.617-4.399l122.084-122.083 c40.037,35.007,90.775,54.132,144.458,54.132c58.718,0,113.919-22.866,155.439-64.386c41.519-41.519,64.385-96.722,64.385-155.439 S489.134,105.905,447.615,64.386z M426.379,354.029c-74.001,74-194.406,74-268.407,0c-74-74-74-194.407,0-268.407 c37.004-37.004,85.596-55.5,134.204-55.5c48.596,0,97.208,18.505,134.204,55.5C500.378,159.621,500.378,280.028,426.379,354.029z" /> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
          </div>

          <a href={WEB_URL} title><img src={logo240} alt="" className="logo" width={51} height={51} /></a>
        </div>
      </div>
    </>
  );
};

// {!props.isLoginPage && <button className="logout-button" onClick={()=> {
//   if(logined){
//     localStorage.clear()
//     document.cookie.split(";").forEach((c) => {
//       document.cookie = c
//         .replace(/^ +/, "")
//         .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
//     });
//   }
//   history.push({pathname: '../login'})
//   }} >{logined ? 'خروج' : 'ورود'}</button>}

export default TopNav;
